import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import { Masonry } from "react-masonry-responsive";
import FormatQuote from "elevate-ui-icons/FormatQuote";

type $Props = {
  classes: Object,
  className: string,
  testimonials: Array<Object>,
};

const Testimonials = ({ classes, className, testimonials }: $Props) => {
  if (!(testimonials && testimonials.length)) {
    return null;
  }
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.testimonialsHeading}>What Clients Are Saying</div>
      <div className={classes.testimonialsMasonry}>
        <Masonry
          items={testimonials.map((testimonial) => ({
            key: testimonial.id,
            node: (
              <div className={classes.testimonial}>
                <div className={classes.testimonialIcon}>
                  <FormatQuote size="32" />
                </div>
                <div
                  className={classes.testimonialDescription}
                  dangerouslySetInnerHTML={{
                    __html: testimonial.description,
                  }}
                />
                <div className={classes.testimonialTitle}>
                  {testimonial.title}
                </div>
              </div>
            ),
          }))}
          minColumnWidth={380}
          containerWidth={970}
        />
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: "#fafafa",
    overflow: "hidden",
    padding: "60px 16px 80px",
    margin: "0px auto",
  },
  testimonialsHeading: {
    fontSize: "24px",
    color: theme.colors.gray["900"],
    fontWeight: "700",
    marginBottom: theme.spacing.unit * 4,
  },
  testimonialsMasonry: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    maxWidth: "970px",
    margin: "0 auto",
    "@media (min-width: 855px)": {
      //[theme.breakpoints('854')]: {
      "& > div > div:last-child": {
        display: (props) => (props.testimonials.length === 1 ? "none" : null),
      },
    },

    "& > div > div:first-child": {
      maxWidth: (props) => (props.testimonials.length === 1 ? "440px" : null),
    },
  },
  testimonial: {
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    padding: "20px 40px 28px",
    overflow: "hidden",
    textAlign: "center",
    backgroundColor: "#fff",
    borderRadius: theme.globalBorderRadius,
    boxShadow:
      "0 16px 16px rgba(103,110,144,.05), 0 8px 8px rgba(103,110,144,.05), 0 4px 4px rgba(103,110,144,.05), 0 2px 2px rgba(103,110,144,.05)",
    flexDirection: "column",
  },
  testimonialIcon: {
    color: theme.colors.gray["300"],
  },
  testimonialTitle: {
    color: theme.colors.gray["700"],
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "1.3",
  },
  testimonialDescription: {
    color: theme.colors.gray["700"],
    fontSize: "16px",
    lineHeight: "1.7",
    paddingBottom: theme.spacing.unit * 0.75,
  },
}))(Testimonials);
